import {    
    GET_BANK_ACCOUNT_REQUEST , 
    GET_BANK_ACCOUNT_UPDATE_REQUEST,
    GET_BANK_ACCOUNT_SUCCESS,
    GET_BANK_ACCOUNT_UPDATE_SUCCESS,
    GET_BANK_ACCOUNT_FAIL,
    GET_BANK_ACCOUNT_UPDATE_FAIL, } from "Redux/types/user";
import {
    GET_ALL_ACCOUNT_REQUEST,
    GET_ALL_ACCOUNT_SUCCESS,
    GET_ALL_ACCOUNT_FAIL,
    GET_ACCOUNT_SUCCESS,
    GET_ACCOUNT_FAIL,
    GET_ACCOUNT_REQUEST,



} from "../types/account";



const initialState = {
    acounts: null,
    account: null,
    bank:null,
    loading: false,
    error: null,
};
const account = (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_ACCOUNT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_ALL_ACCOUNT_SUCCESS:
            return {
                ...state,
                loading: false,
                account: action.payload,
                error:null,
            };
        case GET_ACCOUNT_REQUEST:
            return {
                ...state,
                loading: false,
                
            };
        case GET_ALL_ACCOUNT_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
            
        case GET_ACCOUNT_SUCCESS:
            return {
                ...state,
                loading: false,
                account: action.payload,
                
            };
        case GET_ACCOUNT_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case GET_BANK_ACCOUNT_REQUEST:
            case GET_BANK_ACCOUNT_UPDATE_REQUEST:
            return{
                ...state,
                loading:true,
               
            }
        case GET_BANK_ACCOUNT_SUCCESS:
            case GET_BANK_ACCOUNT_UPDATE_SUCCESS:
            return{
                ...state,
                loading:false,
                bank:action.payload
            }
        case GET_BANK_ACCOUNT_FAIL:
            case GET_BANK_ACCOUNT_UPDATE_FAIL:
            return{
                ...state,
                loading:false,
                error:action.payload
            }
        
       

        default:
            return state;
    }
};

export default account;